import React from "react";

import { useWindowWidth } from "hooks";
import AccessListFiltersContainer from "./AccessListFilters/AccessListFiltersContainer";
import { Header } from "./styled";


const TabAccessListFilters = ({ account_id, accessListLoading }) => {
    const windowWidth = useWindowWidth();
    const isLaptop = windowWidth < 1200;

    return (
        <>
            {!isLaptop && <Header>Access list mailing</Header>}
            <AccessListFiltersContainer />
        </>
    );
};

export default TabAccessListFilters;